export default {
  "contact.hero.breadcrumb_home": "Acasă",
  "contact.hero.breadcrumb_contact": "Contact",
  "contact.hero.title": "Contact",
  "contact.hero.description_line1": "Ai întrebări sau dorești să colaborezi cu FOPMN?",
  "contact.hero.description_line2": "Nu ezita să ne contactezi.",

  "contact.legal.title": "Date Oficiale de Identificare Juridică",
  "contact.legal.name_label": "Denumire completă",
  "contact.legal.name": "FEDERAȚIA ORGANIZAȚIILOR DE PESCARI DE LA MAREA NEAGRĂ",
  "contact.legal.name_desc": "Entitate asociativă de tip umbrelă, reprezentativă a sectorului pescăresc comercial.",
  "contact.legal.fiscal_label": "Identificare Fiscală",
  "contact.legal.fiscal_registered": "Înregistrată conform legislației din România.",
  "contact.legal.fiscal_activity": "Activități ale organizațiilor profesionale",
  "contact.legal.bank_label": "Coordonate Bancare",
  "contact.legal.bank": "BRD - Groupe Société Générale (Unitatea Județeană Constanța)",
  "contact.legal.bank_purpose": "Plată cotizații membri, sponsorizări și fonduri de susținere proiecte.",

  "contact.intro.title": "Contact",
  "contact.intro.text": "Indiferent dacă ești pescar profesionist în căutare de suport, reprezentant al unei instituții publice sau partener comercial, echipa FOPMN îți stă la dispoziție pentru clarificări legislative, asistență tehnică și colaborări strategice. Folosește formularul de mai jos pentru a ne transmite mesajul tău sau contactează-ne direct prin canalele oficiale de comunicare. Îți garantăm o evaluare rapidă și un răspuns fundamentat din partea specialiștilor noștri.",

  "contact.info.title": "Informații de contact",
  "contact.info.address": "Adresă",
  "contact.info.address_value": "Str. Smaraldului nr. 11, ap. 6, Constanța, jud. Constanța, CP: 900001, România",
  "contact.info.president": "Președinte",
  "contact.info.secretary": "Secretar",
  "contact.info.schedule": "Program",
  "contact.info.schedule_value": "Luni – Vineri: 09:00 – 17:00",

  "contact.form.title": "Trimite-ne un mesaj",
  "contact.form.name": "Nume *",
  "contact.form.name_placeholder": "Numele dumneavoastră",
  "contact.form.email": "Email *",
  "contact.form.email_placeholder": "email@exemplu.ro",
  "contact.form.phone": "Telefon",
  "contact.form.phone_placeholder": "+40 7XX XXX XXX",
  "contact.form.subject": "Subiect *",
  "contact.form.subject_select": "Selectați subiectul",
  "contact.form.subject_affiliation": "Afiliere organizație",
  "contact.form.subject_sponsorship": "Sponsorizare",
  "contact.form.subject_programs": "Informații programe",
  "contact.form.subject_collaboration": "Colaborare",
  "contact.form.subject_press": "Presă",
  "contact.form.subject_other": "Altele",
  "contact.form.message": "Mesaj *",
  "contact.form.message_placeholder": "Scrieți mesajul dumneavoastră...",
  "contact.form.consent": "Sunt de acord cu procesarea datelor mele cu caracter personal în scopul soluționării acestei solicitări, conform termenilor stipulați în",
  "contact.form.consent_link": "Politica de confidențialitate",
  "contact.form.consent_suffix": "a FOPMN*",
  "contact.form.consent_error": "Trebuie să acceptați prelucrarea datelor pentru a trimite mesajul.",
  "contact.form.submit": "Trimite mesajul",
  "contact.form.submitting": "Se trimite...",

  "contact.success.title": "Mesaj trimis cu succes!",
  "contact.success.text": "Vă mulțumim pentru mesaj. Vă vom răspunde în cel mai scurt timp posibil.",
  "contact.success.new": "Trimite alt mesaj",
};